import { render, staticRenderFns } from "./QuestionnaireAnswerArea.vue?vue&type=template&id=96e822f4&scoped=true&"
import script from "./QuestionnaireAnswerArea.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireAnswerArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e822f4",
  null
  
)

export default component.exports